import styled, { css } from "styled-components";


export const Wrapper = styled.div(({ theme }) => css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${theme.palette.main.fieldWell};
  border-radius: 15px;

  .input-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-bottom: 15px;

      @media only screen and (min-width: ${theme.breakpoints.M}) {
        flex-direction: row;
    }
  }
  
  .pay-higher-input {
    padding-right: 15px;
    flex: 1;

    input {
      font-weight: ${theme.fonts.headingWeight};
    }
  }

  .start-date-label,
  .pay-higher-input,
  .date-placeholder {
    display: flex;
    flex-direction: column;

    > div {
      background-color: ${theme.palette.main.white};
    }

    label {
      font-weight: ${theme.fonts.headingWeight};
    }
  }

  .start-date-label {
    padding-top: 10px;

    @media only screen and (min-width: ${theme.breakpoints.M}) {
      padding-top: 0;
    }

    option {
        font-family: Lucida Console, Monaco;
    }    
  }

  .manage-repayment-pay-higher-button {
    margin: 15px 0 0;
    background-color: ${theme.buttons.secondary.background};
    color: ${theme.buttons.secondary.color};
    font-size: ${theme.buttons.fontSize};
    font-weight: ${theme.buttons.fontWeight};

    @media (hover: hover) {
      &:hover {
        color: ${theme.buttons.secondary.colorHover};
        background-color: ${theme.buttons.secondary.backgroundHover};
      }
    }
    padding-left: 25px;
  }

  .manage-repayment-submit {
    align-self: flex-end;
  }
`);